import { FC } from 'react';

import { DrawerSection } from 'components/drawerSections/DrawerSections';
import RaaTextAreaField from 'components/fieldComponents/raaTextAreaField/RaaTextAreaField';
import HandelseList from 'components/utkast/handelseList/HandelseList';
import { EnskiltFormValues } from 'components/utkast/utkastRegistration/UtkastFormSchema';

import { HandelseTypEnum } from 'enums';

import { useFormikContext } from 'formik';

const HistorikSection: FC<{ showHandelser?: boolean }> = ({ showHandelser }) => {
  const { values, setFieldValue } = useFormikContext<EnskiltFormValues>();

  return (
    <DrawerSection>
      <fieldset>
        <legend className="tw-heading-md tw-mb-4">Historik</legend>
        <RaaTextAreaField
          label="historik"
          labelClass="tw-sr-only"
          classString="tw-h-[500px] raa-textarea"
          name="historik"
        />
        {showHandelser && (
          <>
            <h3 className="tw-heading-sm tw-mb-4 tw-mt-6">Signifikanta händelser</h3>
            <HandelseList
              handelserValues={values.handelser}
              excludeType={[HandelseTypEnum.NYBYGGNAD, HandelseTypEnum.TILLKOMST]}
              setFieldValue={setFieldValue}
            />
          </>
        )}
      </fieldset>
    </DrawerSection>
  );
};

export default HistorikSection;
